import React from 'react';
import '../App.css';

export default function GM() {
    return (
        <span className="gm">gm</span>
    )
}
